import React, { useEffect, useRef, useState } from "react";
import { nanoid } from "nanoid";
import { createBotMessage, createUserMessage } from "utils/utils";
import { Globalstate } from "context/context";
import { condition } from "context/condition";
import { useWebSocket } from "context/WebSocketProvider";
import useQna from "hooks/useQna";
import assetsMaanager from "assets/assetsmanager/assestsmanager";
import TypingLoader from "component/typingLoader/TypingLoader";
import BotText from "component/BotText/BotText";
import useLikeDislike from "hooks/useLikeDislike";
import botAvatar from "../../assets/photos/botAvatar.svg";
import botAvatarLoading from "../../assets/photos/botAvatarBg.svg";
import "./chatMessage.css";

export const UserMessage = ({ answer }) => {
  return (
    <div className="user-message fade-in">
      <div className="user-message-text">
        <p>{answer.replace(/^“|”$/g, "")}</p>
      </div>
      <div className="user-message-profile-photo">
        <p>Me</p>
      </div>
    </div>
  );
};

export const BotMessage = ({
  answer,
  cta_results,
  recommended_questions,
  userMessage: userMsg,
  responseId,
  isBingResponse,
  isLastMessage,
  messageKey,
  className,
  isTranslatedResponse,
  sourceCode,
  question,
  id,
  nudgeFlag,
  sources
}) => {
  // const formattedAnswer = answer?.replace(/\\n/g, "  \n");
  const formattedAnswer = answer && typeof answer === 'string'
    ? answer.replace(/\\n/g, "  \n")
    : (answer ?? '');

  const { sendMessage } = useWebSocket();
  const [isRecommendedQuestionClicked, setIsRecommendedQuestionClicked] =
    useState(false);
  const {
    dispatch,
    state: { isMessageSubmitted, mode, source, nudgeFlow }
  } = Globalstate();

  const { mutateAsync: mutateAsyncQna } = useQna();
  const { mutateAsync: mutateAsyncLikeDislike } = useLikeDislike();

  const handleSubmit = async (value, isFollowUp) => {
    if (value === "") {
      return;
    }
    if (isMessageSubmitted) return;
    dispatch({ type: condition.ISMESSAGESUBMITTED, payload: true });
    const userKey = nanoid();
    const botKey = nanoid();
    const userMessage = createUserMessage(value, "", userKey);
    const botMessage = createBotMessage("", botKey, "", [], [], "");
    dispatch({
      type: condition.SETMESSGES,
      payload: userMessage
    });
    dispatch({
      type: condition.SETMESSGES,
      payload: botMessage
    });
    if (mode === "qna" || nudgeFlow) {
      await mutateAsyncQna({
        searchTerm: value,
        botKey,
        source: source,
        follow_up_flag: isFollowUp,
        nudgeFlow: nudgeFlow
      });
    } else {
      sendMessage({
        query: value,
        botKey: botKey,
        source: source,
        follow_up_flag: isFollowUp
      });
    }
    dispatch({ type: condition.ISMESSAGESUBMITTED, payload: false });
  };

  const handleTrackCtaClick = (responseId, index, cta_name) => {
    mutateAsyncLikeDislike({
      type: cta_name,
      answer_type: `CTA_${index + 1}`,
      id: responseId,
      sources:
        sources === "fetch_nudge"
          ? "nudge"
          : sources == undefined
            ? "nudge_qna"
            : source
    });
  };

  return (
    <div className="bot-message fade-in">
      <div className="bot-message-profile-photo">
        {answer ? (
          <img
            style={{
              height: "100%",
              width: "100%"
            }}
            src={botAvatar}
            alt=""
          />
        ) : (
          <div style={{ position: "relative" }}>
            <img
              style={{
                height: "100%",
                width: "100%"
              }}
              src={botAvatarLoading}
              alt=""
            />
            <img
              style={{
                height: "100%",
                width: "100%",
                position: "absolute",
                top: "50%",
                left: "0",
                transform: "translate(0,-50%)",
                zIndex: "10"
              }}
              src={assetsMaanager.loaderGif}
              alt=""
            />
          </div>
        )}
      </div>
      {answer !== "" ? (
        <BotText
          className={className}
          isBingResponse={isBingResponse}
          formattedAnswer={formattedAnswer}
          cta_results={cta_results}
          answer={answer}
          userMsg={userMsg}
          responseId={responseId}
          isLastMessage={isLastMessage}
          recommended_questions={recommended_questions}
          isRecommendedQuestionClicked={isRecommendedQuestionClicked}
          messageKey={messageKey}
          handleSubmit={handleSubmit}
          setIsRecommendedQuestionClicked={setIsRecommendedQuestionClicked}
          handleTrackCtaClick={handleTrackCtaClick}
          isTranslatedResponse={isTranslatedResponse}
          sourceCode={sourceCode}
          question={question}
          id={id}
          nudgeFlag={nudgeFlag}
          sources={sources}
        />
      ) :
        (answer === "null") ? "" :
          (
            <TypingLoader />
          )}
    </div>
  );
};

const ChatMessage = ({
  messageSender,
  answer,
  cta_results,
  recommended_questions,
  index,
  userMessage,
  responseId,
  isBingResponse,
  unavailability_flag,
  isLastMessage,
  messageKey,
  isTranslatedResponse,
  sourceCode,
  question,
  id,
  nudgeFlag,
  sources
}) => {
  const containerRef = useRef(null);
  const { state } = Globalstate();
  const { messages } = state;

  useEffect(() => {
    if (containerRef.current && index === messages?.length - 1) {
      containerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, index]);

  const senderType = {
    user: <UserMessage messageKey={messageKey} answer={answer} />,
    bot: (
      <BotMessage
        answer={answer}
        cta_results={cta_results}
        recommended_questions={recommended_questions}
        userMessage={userMessage}
        responseId={responseId}
        isBingResponse={isBingResponse}
        unavailability_flag={unavailability_flag}
        isLastMessage={isLastMessage}
        messageKey={messageKey}
        isTranslatedResponse={isTranslatedResponse}
        sourceCode={sourceCode}
        question={question}
        id={id}
        nudgeFlag={nudgeFlag}
        sources={sources}
      />
    )
  };

  return <div ref={containerRef}>{senderType[messageSender]}</div>;
};

export default ChatMessage;
